import { NAV_ITEMS } from './navigation'

type RouteConfig = {
  match: (path: string) => boolean
  titleKey: string
}

export const ROUTE_TITLES: RouteConfig[] = [
  {
    match: path => /^\/equipment\/[^/]+\/items$/.test(path),
    titleKey: 'navigation.equipment',
  },
  {
    match: path => /^\/departments\/[^/]+$/.test(path),
    titleKey: 'navigation.department',
  },

  ...NAV_ITEMS.map(item => ({
    match: (path: string) => path === item.href || path.startsWith(item.href + '/'),
    titleKey: item.titleKey,
  })),
]
